import { createSelector } from "reselect";
import { RootState } from "RootReducer";
import { PrepListActionTypes } from "../../../types/list/PrepListActionTypes";

export const getIsPrepListLoading = createSelector(
  (state: RootState) => state.loading.loaders,
  (loaders) => loaders.includes(PrepListActionTypes.LOAD_PREP_LIST)
);
